
import { computed, defineComponent } from "vue";
import { useMediaQuery, useWindowScroll } from "@vueuse/core";
import PageContainer from "@/components/PageContainer.vue";
import PageContent from "@/components/PageContent.vue";
import PageTitle from "@/components/PageTitle.vue";
import PostsBlock from "@/components/PostsBlock.vue";
import FollowFestival from "@/components/FollowFestival.vue";

export default defineComponent({
  components: {
    PageContainer,
    PageContent,
    PageTitle,
    PostsBlock,
    FollowFestival,
  },
  setup() {
    const isMobile = useMediaQuery("(max-width: 1025px)");
    const { y } = useWindowScroll();
    const windowHeight = window.innerHeight;
    const backgroundPosition = computed(() =>
      Math.max(50, Math.min(95, 50 + (y.value * 100) / (windowHeight * 2)))
    );

    return {
      baseURL: process.env.BASE_URL,
      isMobile,
      backgroundPosition,
    };
  },
});
